import { useHits } from "react-instantsearch";
import { FinishCard } from "../FinishCard/FinishCard"
import { AlgoliaFinishHit } from "../../types/AlgoliaTypes";

interface MainHitsProps {
    useSteelcaseLink?: boolean;
}

export default function MainHits({useSteelcaseLink} : MainHitsProps) {

    const { hits } = useHits<AlgoliaFinishHit>();
    
    return (
        <div className={"finish-card__list"}>
                    {
                        hits.map((finish) => {
                            return (
                                <FinishCard finish={finish} key={finish.objectID} useSteelcaseLink={useSteelcaseLink} />
                            )
                        })
                    }
        </div>
    )
}